export default "__VITE_ASSET__9kyPr37h__"